import { toFormData } from 'admin/utils';
import { components } from '../schema/docs/api/admin';
import { throwOnError } from './utils';

type Shop = components['schemas']['Shop'];

type PrivateMoney = components['schemas']['PrivateMoney'];

type Coupon = {
  id: string;
  name: string;
  description?: string;
  issued_shop?: Shop;
  private_money?: PrivateMoney;
  starts_at: string | null;
  ends_at: string | null;
  display_starts_at: string | null;
  display_ends_at: string | null;
  discount_amount?: number | null;
  discount_percentage?: number | null;
  discount_upper_limit?: number | null;
  min_amount?: number | null;
  usage_limit?: number | null;
  is_shop_specified?: boolean;
  available_shops?: Shop[];
  is_public?: boolean;
  is_hidden?: boolean;
  code?: string | null;
  coupon_image?: File | Blob | string | null;
  is_disabled?: boolean;
  token?: string;
  num_recipients_cap?: number | null;
  num_recipients?: number | null;
};

type GetCouponsResponse = {
  pagination: {
    current: number;
    per_page: number;
    max_page: number;
    has_prev: boolean;
    has_next: boolean;
  };
  count: number;
  rows: Coupon[];
};

export const fetchCoupons = (query = '') =>
  fetch(`/api/coupons?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<GetCouponsResponse>);

export const fetchCoupon = (id: string) =>
  fetch(`/api/coupons/${id}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<Coupon>);

export const createCoupon = (params: Record<string, unknown> = {}) =>
  fetch('/api/coupons', {
    method: 'POST',
    credentials: 'same-origin',
    body: toFormData(params),
  }).then(throwOnError<Coupon>);

export const updateCoupon = (id: string, params: Record<string, unknown> = {}) =>
  fetch(`/api/coupons/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    body: toFormData(params),
  }).then(throwOnError<Coupon>);
